<template>
  <v-col>
    <v-card v-if="this.reportType.length > 0 && this.insurance.length > 0 && reportData.length > 0">
      <v-card-title primary-title>
        <v-row>
          <v-col lg="4" sm="12">{{ this.reportType }}</v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6" lg="8" class="py-0" text-right>
            <v-text-field
              class="py-0"
              v-model="search"
              label="Search"
              append-icon="mdi-search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="4"
            class="py-0 text-right"
            v-if="
              this.reportType === 'Risk of Readmission' ||
                this.reportType === 'Risk of Hospitalization' ||
                this.reportType === 'High Probability RX Cost' ||
                this.reportType === 'High Probability All Cost'
            "
          >
            <v-btn-toggle v-model="riskToggle" color="secondary" tile mandatory group>
              <v-btn class="text-capitalize" :value="'all'">
                All
              </v-btn>
              <v-btn class="text-capitalize" :value="'high'">
                High
              </v-btn>
              <v-btn class="text-capitalize" :value="'medium'">
                Medium
              </v-btn>
              <v-btn class="text-capitalize" :value="'low'">
                Low
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col cols="12" class="py-0" v-if="tableIsGrouped">
            <div class="float-right">
              <v-btn color="secondary" text small @click="expandAll">Expand All</v-btn>
              <v-btn color="primary" text small @click="collapseAll">Collapse All</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table
        :loading="load"
        :headers="headers"
        :items="filteredData"
        :search="search"
        :footer-props="{
          'items-per-page-options': [25, 50, 75, 100, -1]
        }"
        :items-per-page="25"
        multi-sort
        :show-group-by="!tableIsGrouped"
        @update:group-by="tableIsGrouped = !tableIsGrouped"
        loading-text="Loading data..."
        class="elevation-0 col-md-12 m-auto"
      >
        <template v-slot:item.probability_unplanned_30_day_readmission="{ item }">
          <v-chip dark :color="getChipColor(item.probability_unplanned_30_day_readmission)">{{
            getRisk(item.probability_unplanned_30_day_readmission)
          }}</v-chip>
        </template>

        <template v-slot:group.header="{ group, headers, isOpen, toggle, remove }">
          <td style="background: #fff;" :colspan="headers.length">
            <v-btn @click="toggle" small icon :ref="group" :data-open="isOpen">
              <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
              <v-icon v-else>mdi-chevron-down</v-icon>
            </v-btn>
            <span class="font-weight-bold">{{ group }}</span>
            <v-icon small @click="remove">mdi-close</v-icon>
          </td>
        </template>

        <template v-slot:item.RANK_PROBABILITY_HIGH_TOTAL_COST="{ item }">
          <v-chip dark :color="getChipColor(item.RANK_PROBABILITY_HIGH_TOTAL_COST)">
            {{ getRisk(item.RANK_PROBABILITY_HIGH_TOTAL_COST) }}
          </v-chip>
        </template>

        <template v-slot:item.REFERENCE_PROBABILITY_HIGH_TOTAL_COST="{ item }">
          <v-chip dark :color="getChipColor(item.REFERENCE_PROBABILITY_HIGH_TOTAL_COST)">
            {{ getRisk(item.REFERENCE_PROBABILITY_HIGH_TOTAL_COST) }}
          </v-chip>
        </template>

        <template v-slot:item.LOCAL_PREDICTED_COST_RISK="{ item }">
          {{ item.LOCAL_PREDICTED_COST_RISK.toFixed(2) }}
        </template>

        <template v-slot:item.REFERENCE_PREDICTED_COST_RISK="{ item }">
          {{ item.REFERENCE_PREDICTED_COST_RISK.toFixed(2) }}
        </template>

        <template v-slot:item.HOSP_RISK="{ item }">
          <v-chip dark :color="getChipColor(item.HOSP_RISK)">
            {{ getRisk(item.HOSP_RISK) }}
          </v-chip>
        </template>

        <template v-slot:item.HOSP_RISK_SIX="{ item }">
          <v-chip dark :color="getChipColor(item.HOSP_RISK_SIX)">
            {{ getRisk(item.HOSP_RISK_SIX) }}
          </v-chip>
        </template>

        <template v-slot:item.HOSP_RISK_ICU="{ item }">
          <v-chip dark :color="getChipColor(item.HOSP_RISK_ICU)">
            {{ getRisk(item.HOSP_RISK_ICU) }}
          </v-chip>
        </template>

        <template v-slot:item.HOSP_RISK_INJURY="{ item }">
          <v-chip dark :color="getChipColor(item.HOSP_RISK_INJURY)">
            {{ getRisk(item.HOSP_RISK_INJURY) }}
          </v-chip>
        </template>

        <template v-slot:item.HOSP_RISK_EXT="{ item }">
          <v-chip dark :color="getChipColor(item.HOSP_RISK_EXT)">
            {{ getRisk(item.HOSP_RISK_EXT) }}
          </v-chip>
        </template>

        <template v-slot:item.LOC_COST_RISK="{ item }">
          {{ item.LOC_COST_RISK.toFixed(2) }}
        </template>

        <template v-slot:item.REF_COST_RISK="{ item }">
          {{ item.REF_COST_RISK.toFixed(2) }}
        </template>

        <template v-slot:item.LOC_TOP_PROB="{ item }">
          <v-chip dark :color="getChipColor(item.LOC_TOP_PROB)">
            {{ getRisk(item.LOC_TOP_PROB) }}
          </v-chip>
        </template>

        <template v-slot:item.REF_TOP_PROB="{ item }">
          <v-chip dark :color="getChipColor(item.REF_TOP_PROB)">
            {{ getRisk(item.REF_TOP_PROB) }}
          </v-chip>
        </template>

        <template v-slot:item.DETAILS="{ item }">
          <patient-modal :patient="item" :insurance="insurance" />
        </template>

        <template v-slot:item.ID="{ item }">
          <v-chip
            dark
            @click="openReferenceVsLocalRisk(item.ID, item.member_name, item.pcp_name, item.PRODUCT)"
            >{{ item.ID }}</v-chip
          >
        </template>

        <template v-slot:item.RX_COST_RANGE="{ item }">
          {{ getCostRange(item.RX_COST_RANGE) }}
        </template>

        <template v-slot:item.PREDICTED_COST_RANGE="{ item }">
          {{ getCostRange(item.PREDICTED_COST_RANGE) }}
        </template>

        <template v-slot:item.COST_RANGE="{ item }">
          {{ getCostRange(item.COST_RANGE) }}
        </template>

        <template v-slot:item.PREDICTED_TOTAL_COST_RANGE="{ item }">
          {{ getCostRange(item.PREDICTED_TOTAL_COST_RANGE) }}
        </template>

        <template slot="footer">
          <ExportCSV
            :data="this.csvData"
            :name="
              'Top ' +
                this.reportLimit * 100 +
                '% ' +
                this.reportType +
                ' ' +
                this.startDate +
                '.csv'
            "
          >
            <v-btn color="secondary" text small class="export-button">Export to CSV</v-btn>
          </ExportCSV>
        </template>
      </v-data-table>
      <AiSubReportModal
        :obsPeriod="observationPeriod"
        :memName="memberName"
        :provName="provName"
        :insurance="insurance"
        :startDate="startDate"
        :endDate="endDate"
        :groups="groups"
        :providers="providers"
        :locations="locations"
        :patientID="AiSubReportModalID"
        v-model="AiSubReportModalOverlay"
      />
    </v-card>
  </v-col>
</template>

<script>
import axios from 'axios';
import ExportCSV from 'vue-json-csv';
import PatientModal from '../PatientModal';
import AiSubReportModal from './AiSubReportModal';

export default {
  name: 'AiReports',
  props: [
    'organizations',
    'groups',
    'providers',
    'locations',
    'insurance',
    'startDate',
    'endDate',
    'reportType',
    'data',
    'csvData',
    'reportLimit'
  ],
  components: {
    PatientModal,
    ExportCSV,
    AiSubReportModal,
    ExportCSV,
  },
  data() {
    return {
      tableIsGrouped: false,
      riskToggle: '',
      search: '',
      load: false,
      reportData: [],
      filteredData: [],
      headers: [],
      AiSubReportModalOverlay: false,
      AiSubReportModalID: '',
      memberName: '',
      provName: '',
      observationPeriod: '',
    };
  },
  methods: {
    async openReferenceVsLocalRisk(ID, name, provName, observationPeriod) {
      this.AiSubReportModalOverlay = true;
      this.AiSubReportModalID = ID;
      this.observationPeriod = observationPeriod;
      this.memberName = name;
      this.provName = provName;
    },
    async getHeaders() {
      const reportType = this.reportType.toLowerCase();
      const insurance = this.insurance.toLowerCase();

      if (reportType === 'risk of readmission') {
        this.headers = [
          { text: 'Provider Name', value: 'pcp_name' },
          { text: 'Patient ID', value: 'ID' },
          { text: 'Patient Name', value: 'member_name' },
          { text: 'DOB', value: 'DOB' },
          { text: 'Age', value: 'AGE' },
          { text: 'Sex', value: 'SEX' },
          { text: 'Count of 30 Day Readmissions', value: 'Count_of_30_Day_Readmissions' },
          { text: 'Unplanned 30 Day Readmissions', value: 'unplanned_readmission_30_day_count' },
          {
            text: 'Risk of Readmission in next 30 days',
            value: 'probability_unplanned_30_day_readmission',
          },
          { text: 'Details', value: 'DETAILS' },
        ];
      } else if (reportType === 'risk of hospitalization') {
        this.headers = [
          { text: 'Provider Name', value: 'PROV_NAME' },
          { text: 'Patient ID', value: 'ID' },
          { text: 'Patient Name', value: 'PAT_NAME' },
          { text: 'DOB', value: 'DOB' },
          { text: 'Age', value: 'PAT_AGE' },
          { text: 'Sex', value: 'PAT_SEX' },
          { text: 'Hospitalization Risk', value: 'HOSP_RISK' },
          { text: 'Hospitalization Risk (6 Months)', value: 'HOSP_RISK_SIX' },
          { text: 'ICU Hospitalization Risk', value: 'HOSP_RISK_ICU' },
          { text: 'Injury Related Hospitalization Risk', value: 'HOSP_RISK_INJURY' },
          { text: 'Extended Hospitalization Risk', value: 'HOSP_RISK_EXT' },
          { text: 'Details', value: 'DETAILS' },
        ];
      } else if (reportType === 'predicted cost risk') {
        this.headers = [
          { text: 'Provider Name', value: 'PROV_NAME' },
          { text: 'Patient ID', value: 'ID' },
          { text: 'Patient Name', value: 'PAT_NAME' },
          { text: 'DOB', value: 'DOB' },
          { text: 'Age', value: 'PAT_AGE' },
          { text: 'Sex', value: 'PAT_SEX' },
          { text: 'Local Predicted Cost Risk', value: 'LOC_COST_RISK' },
          { text: 'Reference Predicted Cost Risk', value: 'REF_COST_RISK' },
          { text: 'Predicted Cost Range', value: 'COST_RANGE' },
          { text: 'Details', value: 'DETAILS' },
        ];
      } else if (reportType === 'pharmacy predicted cost risk') {
        this.headers = [
          { text: 'Provider Name', value: 'pcp_name' },
          { text: 'Patient ID', value: 'ID' },
          { text: 'Patient Name', value: 'member_name' },
          { text: 'DOB', value: 'DOB' },
          { text: 'Age', value: 'AGE' },
          { text: 'Sex', value: 'SEX' },
          { text: 'Reference Predicted Cost Risk', value: 'REFERENCE_PREDICTED_COST_RISK' },
          { text: 'Local Predicted Cost Risk', value: 'LOCAL_PREDICTED_COST_RISK' },
          {
            text: 'High Risk Unexpected Rx Cost',
            value: 'HIGH_RISK_UNEXPECTED_RX_COST',
          },
          {
            text: 'Predicted Cost Range',
            value: 'PREDICTED_COST_RANGE',
          },
          { text: 'Details', value: 'DETAILS' },
        ];
      } else if (reportType === 'high probability rx cost') {
        this.headers = [
          { text: 'Provider Name', value: 'PROV_NAME' },
          { text: 'Patient ID', value: 'ID' },
          { text: 'Patient Name', value: 'PAT_NAME' },
          { text: 'DOB', value: 'DOB' },
          { text: 'Age', value: 'PAT_AGE' },
          { text: 'Sex', value: 'PAT_SEX' },
          { text: 'Local Top 5% Probability', value: 'LOC_TOP_PROB' },
          { text: 'Reference Top 5% Probability', value: 'REF_TOP_PROB' },
          { text: 'Predicted RX Cost Range', value: 'RX_COST_RANGE' },
          { text: 'Details', value: 'DETAILS' },
        ];
      } else if (reportType === 'high probability all cost') {
        this.headers = [
          { text: 'Provider Name', value: 'pcp_name' },
          { text: 'Patient ID', value: 'ID' },
          { text: 'Patient Name', value: 'member_name' },
          { text: 'DOB', value: 'DOB' },
          { text: 'Age', value: 'AGE' },
          { text: 'Sex', value: 'SEX' },
          { text: 'Rank Probability High Total Cost', value: 'RANK_PROBABILITY_HIGH_TOTAL_COST' },
          {
            text: 'Reference Probability High Total Cost',
            value: 'REFERENCE_PROBABILITY_HIGH_TOTAL_COST',
          },
          { text: 'Predicted Total Cost Range', value: 'PREDICTED_TOTAL_COST_RANGE' },
          { text: 'Details', value: 'DETAILS' },
        ];
      }
    },
    collapseAll() {
      Object.keys(this.$refs).forEach(k => {
        if (this.$refs[k] && this.$refs[k].$attrs['data-open']) {
          this.$refs[k].$el.click();
        }
      });
    },
    expandAll() {
      Object.keys(this.$refs).forEach(k => {
        if (this.$refs[k] && !this.$refs[k].$attrs['data-open']) {
          this.$refs[k].$el.click();
        }
      });
    },
    getFiltered(risk_level) {
      this.filteredData = [];
      const newArr = [];
      let max = 0;
      let min = 0;
      
      if (risk_level == 'high') {
        min = 0.5;
      } else if (risk_level == 'medium') {
        min = 0.25;
        max = 0.5;
      } else if (risk_level == 'low') {
        max = 0.25;
      }

      // Loop through filteredData when a risk level is chosen, check if values fall within the selected risk level, check if its a number and check that it isn't 'unplanned_readmission_30_day_count' or 'Count_of_30_Day_Readmissions' (these specific fields come through as numbers and throw off the final newField array)
      if (risk_level == 'all') {
        this.filteredData = this.reportData;
      } else {
        this.reportData.forEach((item) => {
          item.newField = [];
          this.headers.forEach((header) => {
            console.log(header, header.value)
            // If the selected risk level is high we don't want to look at cost range fields, those come in as numbers and will always be greater than 1. readmission counts come in as numbers too and can be 0,1,2,3 etc
            if (risk_level == 'high') {
              if (
                header.value != 'unplanned_readmission_30_day_count' && 
                header.value != 'Count_of_30_Day_Readmissions' && 
                header.value != 'PREDICTED_TOTAL_COST_RANGE' &&
                header.value != 'RX_COST_RANGE' &&
                typeof item[header.value] === 'number' && 
                item[header.value] >= min
                ) {
                item.newField.push('Y');
              }
            } else if (risk_level == 'medium') {
              if (
                typeof item[header.value] === 'number' && 
                item[header.value] >= min && 
                item[header.value] < max
                ) {
                item.newField.push('Y');
              }
            } else if (risk_level == 'low') {
              if (
                header.value != 'unplanned_readmission_30_day_count' && 
                header.value != 'Count_of_30_Day_Readmissions' && 
                typeof item[header.value] === 'number' && 
                item[header.value] < max
                ) {
                item.newField.push('Y');
              }
            }
          });
          
          //push to newArr if it has a value that falls within the selected risk level
          if (item.newField.length > 0) {
            newArr.push(item);
          }

          //sort based on the amount of fields that fall within the selected risk level
          newArr.sort((a,b) => {
            return b.newField.length - a.newField.length
          })
          
          this.filteredData = newArr
        });
      }
    },
    getRisk(num) {
      if (num >= 0.5) {
        return 'High';
      }
      if (num < 0.5 && num > 0.25) {
        return 'Medium';
      }
      if (num < 0.25) {
        return 'Low';
      }
    },
    getChipColor(num) {
      if (num >= 0.5) {
        return 'red lighten-1';
      } else if (num >= 0.25) {
        return 'orange lighten-1';
      } else {
        return 'green lighten-1';
      }
    },
    async cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
    getCostRange(num) {
      if (num === 45000) {
        return '$40,000 - $50,000'
      }
      if (num === 35000) {
        return '$30,000 - $40,000'
      }
      if (num === 27500) {
        return '$25,000 - $30,000'
      }
      if (num === 20000) {
        return '$20,000 - $25,000'
      }
      if (num === 15000) {
        return '$15,000 - $20,000'
      }
      if (num === 12500) {
        return '$12,500 - $15,000'
      }
      if (num === 11000) {
        return '$10,000 - $12,500'
      }
      if (num === 10000) {
        return '>$10,000'
      }
      if (num === 8000) {
        return '$7,500 - $10,000'
      }
      if (num === 7500) {
        return '$5,000 - $10,000'
      }
      if (num === 5000) {
        return '$5,000 - $7,500'
      }
      if (num === 4000) {
        return '$3,000 - $5,000'
      }
      if (num === 3000) {
        return '$3,000 - $5,000'
      }
      if (num === 2500) {
        return '$2,000 - $3,000'
      }
      if (num === 2000) {
        return '$2,000 - $3,000'
      }
      if (num === 1750) {
        return '$1,500 - $2,000'
      }
      if (num === 1500) {
        return '$1,000 - $2,000'
      }
      if (num === 1400) {
        return '$1,250 - $1,500'
      }
      if (num === 1000) {
        return '$1,000 - $1,250'
      }
      if (num === 750) {
        return '$5000 - $1,000'
      }
      if (num === 500) {
        return '$500 - $1,000'
      }
      if (num === 300) {
        return '<=$500'
      }
      if (num === 250) {
        return '$250 - $500'
      }
      if (num === 100) {
        return '$100 - $250'
      }
      if (num === 50) {
        return '$50 - $100'
      }
      if (num === 25) {
        return '<$50'
      }
    },
  },
  watch: {
    async riskToggle() {
      this.getFiltered(this.riskToggle);
    },
    data(){
      this.reportData = this.data;
      this.filteredData = this.data;
      this.getHeaders()
    },
  },
};
</script>

<style scoped>
.export-button {
  position: absolute;
  left: 10px;
  bottom: 20px;
}
</style>
